import defaultTpl from "../assets/templates/ReadBarcodes_Default.json";
import speedTpl from "../assets/templates/ReadBarcodes_SpeedFirst.json";
import readRateTpl from "../assets/templates/ReadBarcodes_ReadRateFirst.json";
import globalSettings from "./globalSettings";
import { TemplateName } from "./globalSettings";
import { UniteTypeTpl } from "./typesAndMaps";
import { deepClone } from "./helpers";

export function warpGlobalSettingsFromTemplate(template: any, currentSettings?: any): any {
  const copySettings = deepClone(globalSettings);

  copySettings.TemplateName.value = template.CaptureVisionTemplates[0].Name;
  if(currentSettings) {
    copySettings.BarcodeFormatIds.value = currentSettings.BarcodeFormatIds.value;
    copySettings.Region.value = currentSettings.Region.value;
  }

  // BarcodeZoneMinDistanceToImageBorders
  let BarcodeZoneMinDistanceToImageBorders = template.BarcodeFormatSpecificationOptions[0].BarcodeZoneMinDistanceToImageBorders;
  if (!BarcodeZoneMinDistanceToImageBorders) BarcodeZoneMinDistanceToImageBorders = 0;
  copySettings.BarcodeZoneMinDistanceToImageBorders.value = BarcodeZoneMinDistanceToImageBorders;

  // BinarizationModes
  let BinarizationModes = template.ImageParameterOptions[0].BinarizationModes;
  if (!BinarizationModes) BinarizationModes = [];
  copySettings.BinarizationModes.value.fill("BM_SKIP");
  for (let i = 0; i < BinarizationModes.length; i++) {
    copySettings.BinarizationModes.value[i] = BinarizationModes[i].Mode;
    if (BinarizationModes[i].Mode === "BM_LOCAL_BLOCK") {
      BinarizationModes[i].BlockSizeX && (copySettings.BinarizationModes.options.LocalBlock.args.BlockSizeX.value[i] = BinarizationModes[i].BlockSizeX);
      BinarizationModes[i].BlockSizeY && (copySettings.BinarizationModes.options.LocalBlock.args.BlockSizeY.value[i] = BinarizationModes[i].BlockSizeY);
      BinarizationModes[i].EnableFillBinaryVacancy && (copySettings.BinarizationModes.options.LocalBlock.args.EnableFillBinaryVacancy.value[i] = BinarizationModes[i].EnableFillBinaryVacancy);
      BinarizationModes[i].ThresholdCompensation && (copySettings.BinarizationModes.options.LocalBlock.args.ThresholdCompensation.value[i] = BinarizationModes[i].ThresholdCompensation);
    } else if (BinarizationModes[i].Mode === "BM_THRESHOLD") {
      BinarizationModes[i].BinarizationThreshold && (copySettings.BinarizationModes.options.Threshold.args.BinarizationThreshold.value[i] = BinarizationModes[i].BinarizationThreshold);
    }
  }

  // DeblurModes
  let DeblurModes = template.BarcodeReaderTaskSettingOptions[0].DeblurModes;
  if (!DeblurModes) DeblurModes = [];
  copySettings.DeblurModes.value.fill("DM_SKIP");
  for (let i = 0; i < DeblurModes.length; i++) {
    copySettings.DeblurModes.value[i] = DeblurModes[i].Mode;
  }

  // EnableQRCodeModel1
  let EnableQRCodeModel1 = template.BarcodeFormatSpecificationOptions[0].EnableQRCodeModel1;
  if (undefined === EnableQRCodeModel1) EnableQRCodeModel1 = 0;
  copySettings.EnableQRCodeModel1.value = EnableQRCodeModel1;

  // ExpectedBarcodesCount
  let ExpectedBarcodesCount = template.BarcodeReaderTaskSettingOptions[0].ExpectedBarcodesCount;
  if (undefined === ExpectedBarcodesCount) ExpectedBarcodesCount = 0;
  copySettings.ExpectedBarcodesCount.value = ExpectedBarcodesCount;

  // LocalizationModes
  let LocalizationModes = template.BarcodeReaderTaskSettingOptions[0].LocalizationModes;
  if (!LocalizationModes) LocalizationModes = [];
  copySettings.LocalizationModes.value.fill("LM_SKIP");
  for (let i = 0; i < LocalizationModes.length; i++) {
    copySettings.LocalizationModes.value[i] = LocalizationModes[i].Mode;
    if (LocalizationModes[i].Mode === "LM_CENTRE") {
      LocalizationModes[i].ModuleSize && (copySettings.LocalizationModes.options.Centre.args.ModuleSize.value[i] = LocalizationModes[i].ModuleSize);
    } else if (LocalizationModes[i].Mode === "LM_ONED_FAST_SCAN") {
      LocalizationModes[i].ScanStride && (copySettings.LocalizationModes.options.OneDFastScan.args.ScanStride.value[i] = LocalizationModes[i].ScanStride);
      LocalizationModes[i].ScanDirection && (copySettings.LocalizationModes.options.OneDFastScan.args.ScanDirection.value[i] = LocalizationModes[i].ScanDirection);
      LocalizationModes[i].ConfidenceThreshold && (copySettings.LocalizationModes.options.OneDFastScan.args.ConfidenceThreshold.value[i] = LocalizationModes[i].ConfidenceThreshold);
    } else if (LocalizationModes[i].Mode === "LM_SCAN_DIRECTLY") {
      LocalizationModes[i].ScanStride && (copySettings.LocalizationModes.options.ScanDirectly.args.ScanStride.value[i] = LocalizationModes[i].ScanStride);
      LocalizationModes[i].ScanDirection && (copySettings.LocalizationModes.options.ScanDirectly.args.ScanDirection.value[i] = LocalizationModes[i].ScanDirection);
      LocalizationModes[i].IsOneDStacked && (copySettings.LocalizationModes.options.ScanDirectly.args.ScanDirection.value[i] = LocalizationModes[i].IsOneDStacked);
    }
  }

  // MaxThreadsInOneTask
  let MaxThreadsInOneTask = template.BarcodeReaderTaskSettingOptions[0].MaxThreadsInOneTask;
  if (!MaxThreadsInOneTask) MaxThreadsInOneTask = 4;
  copySettings.MaxThreadsInOneTask.value = MaxThreadsInOneTask;

  // MinResultConfidence
  let MinResultConfidence = template.BarcodeFormatSpecificationOptions[0].MinResultConfidence;
  if (!MinResultConfidence) MinResultConfidence = 30;
  copySettings.MinResultConfidence.value = MinResultConfidence;

  // ScaleDownThreshold
  let ScaleDownThreshold = template.ImageParameterOptions[0].ScaleDownThreshold;
  if (!ScaleDownThreshold) ScaleDownThreshold = 2300;
  copySettings.ScaleDownThreshold.value = ScaleDownThreshold;

  // ScaleUpModes
  let ScaleUpModes = template.ImageParameterOptions[0].ScaleUpModes;
  if (!ScaleUpModes) ScaleUpModes = [];
  copySettings.ScaleUpModes.value.fill("SUM_SKIP");
  for (let i = 0; i < ScaleUpModes.length; i++) {
    copySettings.ScaleUpModes.value[i] = ScaleUpModes[i].Mode;
    if (ScaleUpModes[i].Mode === "SUM_LINEAR_INTERPOLATION") {
      ScaleUpModes[i].ModuleSize && (copySettings.ScaleUpModes.options.LinearInterpolation.args.AcuteAngleWithXThreshold.value[i] = ScaleUpModes[i].AcuteAngleWithXThreshold);
      ScaleUpModes[i].ModuleSizeThreshold && (copySettings.ScaleUpModes.options.LinearInterpolation.args.ModuleSizeThreshold.value[i] = ScaleUpModes[i].ModuleSizeThreshold);
      ScaleUpModes[i].ModuleSize && (copySettings.ScaleUpModes.options.LinearInterpolation.args.TargetModuleSize.value[i] = ScaleUpModes[i].TargetModuleSize);
    } else if (ScaleUpModes[i].Mode === "SUM_NEAREST_NEIGHBOUR_INTERPOLATION") {
      ScaleUpModes[i].AcuteAngleWithXThreshold && (copySettings.ScaleUpModes.options.NearestNeighbourInterpolation.args.AcuteAngleWithXThreshold.value[i] = ScaleUpModes[i].AcuteAngleWithXThreshold);
      ScaleUpModes[i].ModuleSizeThreshold && (copySettings.ScaleUpModes.options.NearestNeighbourInterpolation.args.ModuleSizeThreshold.value[i] = ScaleUpModes[i].ModuleSizeThreshold);
      ScaleUpModes[i].TargetModuleSize && (copySettings.ScaleUpModes.options.NearestNeighbourInterpolation.args.TargetModuleSize.value[i] = ScaleUpModes[i].TargetModuleSize);
    }
  }

  // TextResultOrderModes
  let TextResultOrderModes = template.BarcodeReaderTaskSettingOptions[0].TextResultOrderModes;
  if (!TextResultOrderModes) TextResultOrderModes = [];
  copySettings.TextResultOrderModes.value.fill("TROM_SKIP");
  for (let i = 0; i < TextResultOrderModes.length; i++) {
    copySettings.TextResultOrderModes.value[i] = TextResultOrderModes[i].Mode;
  }

  // Timeout
  let Timeout = template.CaptureVisionTemplates[0].Timeout;
  if (!Timeout) Timeout = 10000;
  copySettings.Timeout.value = Timeout;

  // furtherModes start
  let furtherModes = copySettings.FurtherModes.inside;

  // BarcodeColourModes
  let BarcodeColourModes = template.BarcodeReaderTaskSettingOptions[0].BarcodeColourModes;
  if (!BarcodeColourModes) BarcodeColourModes = [];
  furtherModes.BarcodeColourModes.value.fill("BICM_SKIP");
  for (let i = 0; i < BarcodeColourModes.length; i++) {
    furtherModes.BarcodeColourModes.value[i] = BarcodeColourModes[i].Mode;
    if (BarcodeColourModes[i].Mode === "BICM_DARK_ON_LIGHT") {
      BarcodeColourModes[i].LightReflection && (furtherModes.BarcodeColourModes.options.DarkOnLight.args.LightReflection.value[i] = BarcodeColourModes[i].LightReflection);
    } else if (BarcodeColourModes[i].Mode === "BICM_LIGHT_ON_DARK") {
      BarcodeColourModes[i].LightReflection && (furtherModes.BarcodeColourModes.options.LightOnDark.args.LightReflection.value[i] = BarcodeColourModes[i].LightReflection);
    } else if (BarcodeColourModes[i].Mode === "BICM_DARK_ON_DARK") {
      BarcodeColourModes[i].LightReflection && (furtherModes.BarcodeColourModes.options.DarkOnDark.args.LightReflection.value[i] = BarcodeColourModes[i].LightReflection);
    } else if (BarcodeColourModes[i].Mode === "BICM_LIGHT_ON_LIGHT") {
      BarcodeColourModes[i].LightReflection && (furtherModes.BarcodeColourModes.options.LightOnLight.args.LightReflection.value[i] = BarcodeColourModes[i].LightReflection);
    } else if (BarcodeColourModes[i].Mode === "BICM_DARK_LIGHT_MIXED") {
      BarcodeColourModes[i].LightReflection && (furtherModes.BarcodeColourModes.options.DarkLightMixed.args.LightReflection.value[i] = BarcodeColourModes[i].LightReflection);
    } else if (BarcodeColourModes[i].Mode === "BICM_DARK_ON_LIGHT_DARK_SURROUNDING") {
      BarcodeColourModes[i].LightReflection && (furtherModes.BarcodeColourModes.options.DarkOnLightDarkSurrounding.args.LightReflection.value[i] = BarcodeColourModes[i].LightReflection);
    }
  }

  // BarcodeComplementModes
  let BarcodeComplementModes = template.BarcodeReaderTaskSettingOptions[0].BarcodeComplementModes;
  if (!BarcodeComplementModes) BarcodeComplementModes = [];
  furtherModes.BarcodeComplementModes.value.fill("BCM_SKIP");
  for (let i = 0; i < BarcodeComplementModes.length; i++) {
    furtherModes.BarcodeComplementModes.value[i] = BarcodeComplementModes[i].Mode;
  }

  //ColourConversionModes
  let ColourConversionModes = template.ImageParameterOptions[0].ColourConversionModes;
  if (!ColourConversionModes) ColourConversionModes = [];
  furtherModes.ColourConversionModes.value.fill("CICM_SKIP");
  for (let i = 0; i < ColourConversionModes.length; i++) {
    furtherModes.ColourConversionModes.value[i] = ColourConversionModes[i].Mode;
    if (ColourConversionModes[i].Mode === "CICM_GENERAL") {
      ColourConversionModes[i].BlueChannelWeight && (furtherModes.ColourConversionModes.options.General.args.BlueChannelWeight.value[i] = ColourConversionModes[i].BlueChannelWeight);
      ColourConversionModes[i].GreenChannelWeight && (furtherModes.ColourConversionModes.options.General.args.GreenChannelWeight.value[i] = ColourConversionModes[i].GreenChannelWeight);
      ColourConversionModes[i].RedChannelWeight && (furtherModes.ColourConversionModes.options.General.args.RedChannelWeight.value[i] = ColourConversionModes[i].RedChannelWeight);
    }
  }

  // DPMCodeReadingModes
  let DPMCodeReadingModes = template.BarcodeReaderTaskSettingOptions[0].DPMCodeReadingModes;
  if (!DPMCodeReadingModes) DPMCodeReadingModes = [];
  furtherModes.DPMCodeReadingModes.value.fill("DPMCRM_SKIP");
  for (let i = 0; i < DPMCodeReadingModes.length; i++) {
    furtherModes.DPMCodeReadingModes.value[i] = DPMCodeReadingModes[i].Mode;
  }

  // DeformationResistingModes
  let DeformationResistingModes = template.BarcodeReaderTaskSettingOptions[0].DeformationResistingModes;
  if (!DeformationResistingModes) DeformationResistingModes = [];
  furtherModes.DeformationResistingModes.value.fill("DRM_SKIP");
  for (let i = 0; i < DeformationResistingModes.length; i++) {
    furtherModes.DeformationResistingModes.value[i] = DeformationResistingModes[i].Mode;
    if (DeformationResistingModes[i].Mode === "DRM_GENERAL") {
      DeformationResistingModes[i].Level && (furtherModes.DeformationResistingModes.options.General.args.Level.value[i] = DeformationResistingModes[i].Level);
    }
  }

  // GrayscaleEnhancementModes
  let GrayscaleEnhancementModes = template.ImageParameterOptions[0].GrayscaleEnhancementModes;
  if (!GrayscaleEnhancementModes) GrayscaleEnhancementModes = [];
  furtherModes.GrayscaleEnhancementModes.value.fill("GEM_SKIP");
  for (let i = 0; i < GrayscaleEnhancementModes.length; i++) {
    furtherModes.GrayscaleEnhancementModes.value[i] = GrayscaleEnhancementModes[i].Mode;
    if (GrayscaleEnhancementModes[i].Mode === "GEM_GRAY_EQUALIZE") {
      GrayscaleEnhancementModes[i].Sensitivity && (furtherModes.GrayscaleEnhancementModes.options.GrayEqualize.args.Sensitivity.value[i] = GrayscaleEnhancementModes[i].Sensitivity);
    } else if (GrayscaleEnhancementModes[i].Mode === "GEM_GRAY_SMOOTH") {
      GrayscaleEnhancementModes[i].SmoothBlockSizeX && (furtherModes.GrayscaleEnhancementModes.options.GraySmooth.args.SmoothBlockSizeX.value[i] = GrayscaleEnhancementModes[i].SmoothBlockSizeX);
      GrayscaleEnhancementModes[i].SmoothBlockSizeY && (furtherModes.GrayscaleEnhancementModes.options.GraySmooth.args.SmoothBlockSizeY.value[i] = GrayscaleEnhancementModes[i].SmoothBlockSizeY);
    } else if (GrayscaleEnhancementModes[i].Mode === "GEM_SHARPEN_SMOOTH") {
      GrayscaleEnhancementModes[i].SmoothBlockSizeX && (furtherModes.GrayscaleEnhancementModes.options.SharpenSmooth.args.SmoothBlockSizeX.value[i] = GrayscaleEnhancementModes[i].SmoothBlockSizeX);
      GrayscaleEnhancementModes[i].SmoothBlockSizeY && (furtherModes.GrayscaleEnhancementModes.options.SharpenSmooth.args.SmoothBlockSizeY.value[i] = GrayscaleEnhancementModes[i].SmoothBlockSizeY);
      GrayscaleEnhancementModes[i].SharpenBlockSizeX && (furtherModes.GrayscaleEnhancementModes.options.SharpenSmooth.args.SharpenBlockSizeX.value[i] = GrayscaleEnhancementModes[i].SharpenBlockSizeX);
      GrayscaleEnhancementModes[i].SharpenBlockSizeY && (furtherModes.GrayscaleEnhancementModes.options.SharpenSmooth.args.SharpenBlockSizeY.value[i] = GrayscaleEnhancementModes[i].SharpenBlockSizeY);
    }
  }

  // GrayscaleTransformationModes
  let GrayscaleTransformationModes = template.ImageParameterOptions[0].GrayscaleTransformationModes;
  if (!GrayscaleTransformationModes) GrayscaleTransformationModes = [];
  furtherModes.GrayscaleTransformationModes.value.fill("GTM_AUTO");
  for (let i = 0; i < GrayscaleTransformationModes.length; i++) {
    furtherModes.GrayscaleTransformationModes.value[i] = GrayscaleTransformationModes[i].Mode;
  }

  // RegionPredetectionModes
  let RegionPredetectionModes = template.ImageParameterOptions[0].RegionPredetectionModes;
  if (!RegionPredetectionModes) RegionPredetectionModes = [];
  furtherModes.RegionPredetectionModes.value.fill("RPM_SKIP");
  for (let i = 0; i < RegionPredetectionModes.length; i++) {
    furtherModes.RegionPredetectionModes.value[i] = RegionPredetectionModes[i].Mode;
    if (RegionPredetectionModes[i].Mode === "RPM_GENERAL_RGB_CONTRAST") {
      RegionPredetectionModes[i].MinImageDimension && (furtherModes.RegionPredetectionModes.options.RGB.args.MinImageDimension.value[i] = RegionPredetectionModes[i].MinImageDimension);
      RegionPredetectionModes[i].Sensitivity && (furtherModes.RegionPredetectionModes.options.RGB.args.Sensitivity.value[i] = RegionPredetectionModes[i].Sensitivity);
      RegionPredetectionModes[i].SpatialIndexBlockSize && (furtherModes.RegionPredetectionModes.options.RGB.args.SpatialIndexBlockSize.value[i] = RegionPredetectionModes[i].SpatialIndexBlockSize);
    } else if (RegionPredetectionModes[i].Mode === "RPM_GENERAL_GRAY_CONTRAST") {
      RegionPredetectionModes[i].MinImageDimension && (furtherModes.RegionPredetectionModes.options.Gray.args.MinImageDimension.value[i] = RegionPredetectionModes[i].MinImageDimension);
      RegionPredetectionModes[i].Sensitivity && (furtherModes.RegionPredetectionModes.options.Gray.args.Sensitivity.value[i] = RegionPredetectionModes[i].Sensitivity);
      RegionPredetectionModes[i].SpatialIndexBlockSize && (furtherModes.RegionPredetectionModes.options.Gray.args.SpatialIndexBlockSize.value[i] = RegionPredetectionModes[i].SpatialIndexBlockSize);
    } else if (RegionPredetectionModes[i].Mode === "RPM_GENERAL_HSV_CONTRAST") {
      RegionPredetectionModes[i].MinImageDimension && (furtherModes.RegionPredetectionModes.options.HSV.args.MinImageDimension.value[i] = RegionPredetectionModes[i].MinImageDimension);
      RegionPredetectionModes[i].Sensitivity && (furtherModes.RegionPredetectionModes.options.HSV.args.Sensitivity.value[i] = RegionPredetectionModes[i].Sensitivity);
      RegionPredetectionModes[i].SpatialIndexBlockSize && (furtherModes.RegionPredetectionModes.options.HSV.args.SpatialIndexBlockSize.value[i] = RegionPredetectionModes[i].SpatialIndexBlockSize);
    }
  }

  // TextureDetectionModes
  let TextureDetectionModes = template.ImageParameterOptions[0].TextureDetectionModes;
  if (!TextureDetectionModes) TextureDetectionModes = [];
  furtherModes.TextureDetectionModes.value.fill("TDM_SKIP");
  for (let i = 0; i < TextureDetectionModes.length; i++) {
    furtherModes.TextureDetectionModes.value[i] = TextureDetectionModes[i].Mode;
    if (TextureDetectionModes[i].Mode === "TDM_GENERAL_WIDTH_CONCENTRATION") {
      TextureDetectionModes[i].Sensitivity && (furtherModes.TextureDetectionModes.options.GeneralWidthConcentration.args.Sensitivity.value[i] = TextureDetectionModes[i].Sensitivity);
    }
  }

  return copySettings;
}

export function warpTemplateFromGlobalSettings(settings: any): UniteTypeTpl {
  const templateMap = {
    "ReadBarcodes_Default": defaultTpl,
    "ReadBarcodes_ReadRateFirst": readRateTpl,
    "ReadBarcodes_SpeedFirst": speedTpl
  }
  const _template = templateMap[settings.TemplateName.value as TemplateName];
  const currentTpl = deepClone(_template) as typeof _template;
  currentTpl.BarcodeReaderTaskSettingOptions[0].BarcodeFormatIds = settings.BarcodeFormatIds.value;

  for (let bfso of currentTpl.BarcodeFormatSpecificationOptions) {
    bfso.BarcodeZoneMinDistanceToImageBorders = settings.BarcodeZoneMinDistanceToImageBorders.value;
    bfso.EnableQRCodeModel1 = settings.EnableQRCodeModel1.value;
    bfso.MinResultConfidence = settings.MinResultConfidence.value;
  }

  for (let brtso of currentTpl.BarcodeReaderTaskSettingOptions) {
    brtso.ExpectedBarcodesCount = settings.ExpectedBarcodesCount.value;
    brtso.MaxThreadsInOneTask = settings.MaxThreadsInOneTask.value;
  }

  for (let ipo of currentTpl.ImageParameterOptions) {
    ipo.ScaleDownThreshold = settings.ScaleDownThreshold.value;
  }

  for (let cvts of currentTpl.CaptureVisionTemplates) {
    cvts.Timeout = settings.Timeout.value;
  }

  for (let trdo of currentTpl.TargetROIDefOptions) {
    if (settings.Region.value) {
      const isPercentage = settings.Region.value.RegionMeasuredByPercentage;
      const region = settings.Region.value;
      trdo.Location.Offset.MeasuredByPercentage = isPercentage;
      trdo.Location.Offset.FirstPoint = [region.RegionLeft, region.RegionTop, isPercentage, isPercentage];
      trdo.Location.Offset.SecondPoint = [region.RegionRight, region.RegionTop, isPercentage, isPercentage];
      trdo.Location.Offset.ThirdPoint = [region.RegionRight, region.RegionBottom, isPercentage, isPercentage];
      trdo.Location.Offset.FourthPoint = [region.RegionLeft, region.RegionBottom, isPercentage, isPercentage];
    }
  }

  // BinarizationModes
  currentTpl.ImageParameterOptions[0].BinarizationModes = [];
  if (_isOnlyHas(settings.BinarizationModes.value, "BM_SKIP")) {
    (currentTpl as any).ImageParameterOptions[0].BinarizationModes = [{
      Mode: "BM_SKIP"
    }];
  } else {
    const removeIndex = _removeItemIndex(settings.BinarizationModes.value);
    for (let i = 0; i < settings.BinarizationModes.value.length; i++) {
      if (removeIndex === i) break;
      const item: any = {
        Mode: settings.BinarizationModes.value[i],
      }
      if (settings.BinarizationModes.value[i] === "BM_LOCAL_BLOCK") {
        item.BlockSizeX = settings.BinarizationModes.options.LocalBlock.args.BlockSizeX.value[i];
        item.BlockSizeY = settings.BinarizationModes.options.LocalBlock.args.BlockSizeY.value[i];
        item.EnableFillBinaryVacancy = settings.BinarizationModes.options.LocalBlock.args.EnableFillBinaryVacancy.value[i];
        item.ThresholdCompensation = settings.BinarizationModes.options.LocalBlock.args.ThresholdCompensation.value[i];
      } else if (settings.BinarizationModes.value[i] === "BM_THRESHOLD") {
        item.BinarizationThreshold = settings.BinarizationModes.options.Threshold.args.BinarizationThreshold.value[i];
      }
      currentTpl.ImageParameterOptions[0].BinarizationModes.push(item);
    }
  }

  // DeblurModes
  currentTpl.BarcodeReaderTaskSettingOptions[0].DeblurModes = [];
  if (_isOnlyHas(settings.DeblurModes.value, "DM_SKIP")) {
    currentTpl.BarcodeReaderTaskSettingOptions[0].DeblurModes = null;
  } else {
    const removeIndex = _removeItemIndex(settings.DeblurModes.value);
    for (let i = 0; i < settings.DeblurModes.value.length; i++) {
      if (removeIndex === i) break;
      const item: any = {
        Mode: settings.DeblurModes.value[i],
      }
      currentTpl.BarcodeReaderTaskSettingOptions[0].DeblurModes.push(item);
    }
  }

  // LocalizationModes
  currentTpl.BarcodeReaderTaskSettingOptions[0].LocalizationModes = [];
  if (_isOnlyHas(settings.LocalizationModes.value, "LM_SKIP")) {
    (currentTpl as any).BarcodeReaderTaskSettingOptions[0].LocalizationModes = [{
      Mode: "LM_SKIP"
    }];
  } else {
    const removeIndex = _removeItemIndex(settings.LocalizationModes.value);
    for (let i = 0; i < settings.LocalizationModes.value.length; i++) {
      if (removeIndex === i) break;
      const item: any = {
        Mode: settings.LocalizationModes.value[i],
      }
      if (settings.LocalizationModes.value[i] === "LM_CENTRE") {
        item.ModuleSize = settings.LocalizationModes.options.Centre.args.ModuleSize.value[i];
      } else if (settings.LocalizationModes.value[i] === "LM_ONED_FAST_SCAN") {
        item.ScanStride = settings.LocalizationModes.options.OneDFastScan.args.ScanStride.value[i];
        item.ScanDirection = settings.LocalizationModes.options.OneDFastScan.args.ScanDirection.value[i];
        item.ConfidenceThreshold = settings.LocalizationModes.options.OneDFastScan.args.ConfidenceThreshold.value[i];
      } else if (settings.LocalizationModes.value[i] === "LM_SCAN_DIRECTLY") {
        item.ScanStride = settings.LocalizationModes.options.ScanDirectly.args.ScanStride.value[i];
        item.ScanDirection = settings.LocalizationModes.options.ScanDirectly.args.ScanDirection.value[i];
        item.IsOneDStacked = settings.LocalizationModes.options.ScanDirectly.args.IsOneDStacked.value[i];
      }
      currentTpl.BarcodeReaderTaskSettingOptions[0].LocalizationModes.push(item);
    }
  }

  // ScaleUpModes
  currentTpl.ImageParameterOptions[0].ScaleUpModes = [];
  if (_isOnlyHas(settings.ScaleUpModes.value, "SUM_SKIP")) {
    (currentTpl as any).ImageParameterOptions[0].ScaleUpModes = [{
      Mode: "SUM_SKIP"
    }];
  } else {
    const removeIndex = _removeItemIndex(settings.ScaleUpModes.value);
    for (let i = 0; i < settings.ScaleUpModes.value.length; i++) {
      if (removeIndex === i) break;
      const item: any = {
        Mode: settings.ScaleUpModes.value[i],
      }
      if (settings.ScaleUpModes.value[i] === "SUM_LINEAR_INTERPOLATION") {
        item.AcuteAngleWithXThreshold = settings.ScaleUpModes.options.LinearInterpolation.args.AcuteAngleWithXThreshold.value[i];
        item.ModuleSizeThreshold = settings.ScaleUpModes.options.LinearInterpolation.args.ModuleSizeThreshold.value[i];
        item.TargetModuleSize = settings.ScaleUpModes.options.LinearInterpolation.args.TargetModuleSize.value[i];
      } else if (settings.ScaleUpModes.value[i] === "SUM_NEAREST_NEIGHBOUR_INTERPOLATION") {
        item.AcuteAngleWithXThreshold = settings.ScaleUpModes.options.NearestNeighbourInterpolation.args.AcuteAngleWithXThreshold.value[i];
        item.ModuleSizeThreshold = settings.ScaleUpModes.options.NearestNeighbourInterpolation.args.ModuleSizeThreshold.value[i];
        item.TargetModuleSize = settings.ScaleUpModes.options.NearestNeighbourInterpolation.args.TargetModuleSize.value[i];
      }
      currentTpl.ImageParameterOptions[0].ScaleUpModes.push(item);
    }
  }

  // TextResultOrderModes
  currentTpl.BarcodeReaderTaskSettingOptions[0].TextResultOrderModes = [];
  if (_isOnlyHas(settings.TextResultOrderModes.value, "TROM_SKIP")) {
    (currentTpl as any).BarcodeReaderTaskSettingOptions[0].TextResultOrderModes = [{
      Mode: "TROM_SKIP"
    }];
  } else {
    const removeIndex = _removeItemIndex(settings.TextResultOrderModes.value);
    for (let i = 0; i < settings.TextResultOrderModes.value.length; i++) {
      if (removeIndex === i) break;
      const item: any = {
        Mode: settings.TextResultOrderModes.value[i],
      }
      currentTpl.BarcodeReaderTaskSettingOptions[0].TextResultOrderModes.push(item);
    }
  }

  // furtherModes start
  let furtherModes = settings.FurtherModes.inside;

  // BarcodeColourModes
  currentTpl.BarcodeReaderTaskSettingOptions[0].BarcodeColourModes = [] as any;
  if (_isOnlyHas(furtherModes.BarcodeColourModes.value, "BICM_SKIP")) {
    currentTpl.BarcodeReaderTaskSettingOptions[0].BarcodeColourModes = null;
  } else {
    const removeIndex = _removeItemIndex(furtherModes.BarcodeColourModes.value);
    for (let i = 0; i < furtherModes.BarcodeColourModes.value.length; i++) {
      if (removeIndex === i) break;
      const item = {
        Mode: furtherModes.BarcodeColourModes.value[i],
      } as any
      if (furtherModes.BarcodeColourModes.value[i] === "BICM_DARK_ON_LIGHT") {
        item.LightReflection = furtherModes.BarcodeColourModes.options.DarkOnLight.args.LightReflection.value[i];
      } else if (furtherModes.BarcodeColourModes.value[i] === "BICM_LIGHT_ON_DARK") {
        item.LightReflection = furtherModes.BarcodeColourModes.options.LightOnDark.args.LightReflection.value[i];
      } else if (furtherModes.BarcodeColourModes.value[i] === "BICM_DARK_ON_DARK") {
        item.LightReflection = furtherModes.BarcodeColourModes.options.DarkOnDark.args.LightReflection.value[i];
      } else if (furtherModes.BarcodeColourModes.value[i] === "BICM_LIGHT_ON_LIGHT") {
        item.LightReflection = furtherModes.BarcodeColourModes.options.LightOnLight.args.LightReflection.value[i];
      } else if (furtherModes.BarcodeColourModes.value[i] === "BICM_DARK_LIGHT_MIXED") {
        item.LightReflection = furtherModes.BarcodeColourModes.options.DarkLightMixed.args.LightReflection.value[i];
      } else if (furtherModes.BarcodeColourModes.value[i] === "BICM_DARK_ON_LIGHT_DARK_SURROUNDING") {
        item.LightReflection = furtherModes.BarcodeColourModes.options.DarkOnLightDarkSurrounding.args.LightReflection.value[i];
      }
      (currentTpl.BarcodeReaderTaskSettingOptions[0].BarcodeColourModes as any).push(item);
    }
  }

  // BarcodeComplementModes
  currentTpl.BarcodeReaderTaskSettingOptions[0].BarcodeComplementModes = [];
  if (_isOnlyHas(furtherModes.BarcodeComplementModes.value, "BCM_SKIP")) {
    (currentTpl as any).BarcodeReaderTaskSettingOptions[0].BarcodeComplementModes = [{
      Mode: "BCM_SKIP"
    }];
  } else {
    const removeIndex = _removeItemIndex(furtherModes.BarcodeComplementModes.value);
    for (let i = 0; i < furtherModes.BarcodeComplementModes.value.length; i++) {
      if (removeIndex === i) break;
      const item = {
        Mode: furtherModes.BarcodeComplementModes.value[i],
      }
      currentTpl.BarcodeReaderTaskSettingOptions[0].BarcodeComplementModes.push(item);
    }
  }

  // ColourConversionModes
  currentTpl.ImageParameterOptions[0].ColourConversionModes = [];
  if (_isOnlyHas(furtherModes.ColourConversionModes.value, "CICM_SKIP")) {
    (currentTpl as any).ImageParameterOptions[0].ColourConversionModes = [{
      Mode: "CICM_SKIP"
    }];
  } else {
    const removeIndex = _removeItemIndex(furtherModes.ColourConversionModes.value);
    for (let i = 0; i < furtherModes.ColourConversionModes.value.length; i++) {
      if (removeIndex === i) break;
      const item: any = {
        Mode: furtherModes.ColourConversionModes.value[i],
      }
      if (furtherModes.ColourConversionModes.value[i] === "CICM_GENERAL") {
        item.BlueChannelWeight = furtherModes.ColourConversionModes.options.General.args.BlueChannelWeight.value[i];
        item.GreenChannelWeight = furtherModes.ColourConversionModes.options.General.args.GreenChannelWeight.value[i];
        item.RedChannelWeight = furtherModes.ColourConversionModes.options.General.args.RedChannelWeight.value[i];
      }
      currentTpl.ImageParameterOptions[0].ColourConversionModes.push(item);
    }
  }

  // DPMCodeReadingModes
  currentTpl.BarcodeReaderTaskSettingOptions[0].DPMCodeReadingModes = [];
  if (_isOnlyHas(furtherModes.DPMCodeReadingModes.value, "DPMCRM_SKIP")) {
    (currentTpl as any).BarcodeReaderTaskSettingOptions[0].DPMCodeReadingModes = [{
      Mode: "DPMCRM_SKIP"
    }];
  } else {
    const removeIndex = _removeItemIndex(furtherModes.DPMCodeReadingModes.value);
    for (let i = 0; i < furtherModes.DPMCodeReadingModes.value.length; i++) {
      if (removeIndex === i) break;
      const item = {
        Mode: furtherModes.DPMCodeReadingModes.value[i],
        BarcodeFormat: "BF_DATAMATRIX",
      }
      currentTpl.BarcodeReaderTaskSettingOptions[0].DPMCodeReadingModes.push(item);
    }
  }

  // DeformationResistingModes
  currentTpl.BarcodeReaderTaskSettingOptions[0].DeformationResistingModes = [];
  if (_isOnlyHas(furtherModes.DeformationResistingModes.value, "DRM_SKIP")) {
    (currentTpl as any).BarcodeReaderTaskSettingOptions[0].DeformationResistingModes = [{
      "Mode": "DRM_SKIP"
    }];
  } else {
    const removeIndex = _removeItemIndex(furtherModes.DeformationResistingModes.value);
    for (let i = 0; i < furtherModes.DeformationResistingModes.value.length; i++) {
      if (removeIndex === i) break;
      const item: any = {
        Mode: furtherModes.DeformationResistingModes.value[i],
        Level: 5
      }
      if (furtherModes.DeformationResistingModes.value[i] === "DRM_GENERAL") {
        item.Level = furtherModes.DeformationResistingModes.options.General.args.Level.value[i];
      }
      currentTpl.BarcodeReaderTaskSettingOptions[0].DeformationResistingModes.push(item);
    }
  }

  // GrayscaleEnhancementModes
  currentTpl.ImageParameterOptions[0].GrayscaleEnhancementModes = [];
  if (_isOnlyHas(furtherModes.GrayscaleEnhancementModes.value, "GEM_SKIP")) {
    (currentTpl as any).ImageParameterOptions[0].GrayscaleEnhancementModes = [{
      Mode: "GEM_SKIP"
    }];
  } else {
    const removeIndex = _removeItemIndex(furtherModes.GrayscaleEnhancementModes.value);
    for (let i = 0; i < furtherModes.GrayscaleEnhancementModes.value.length; i++) {
      if (removeIndex === i) break;
      const item: any = {
        Mode: furtherModes.GrayscaleEnhancementModes.value[i]
      }
      if (furtherModes.GrayscaleEnhancementModes.value[i] === "GEM_GRAY_EQUALIZE") {
        item.Sensitivity = furtherModes.GrayscaleEnhancementModes.options.GrayEqualize.args.Sensitivity.value[i];
      } else if (furtherModes.GrayscaleEnhancementModes.value[i] === "GEM_GRAY_SMOOTH") {
        item.SmoothBlockSizeX = furtherModes.GrayscaleEnhancementModes.options.GraySmooth.args.SmoothBlockSizeX.value[i];
        item.SmoothBlockSizeY = furtherModes.GrayscaleEnhancementModes.options.GraySmooth.args.SmoothBlockSizeY.value[i];
      } else if (furtherModes.GrayscaleEnhancementModes.value[i] === "GEM_SHARPEN_SMOOTH") {
        item.SmoothBlockSizeX = furtherModes.GrayscaleEnhancementModes.options.SharpenSmooth.args.SmoothBlockSizeX.value[i];
        item.SmoothBlockSizeY = furtherModes.GrayscaleEnhancementModes.options.SharpenSmooth.args.SmoothBlockSizeY.value[i];
        item.SharpenBlockSizeX = furtherModes.GrayscaleEnhancementModes.options.SharpenSmooth.args.SharpenBlockSizeX.value[i];
        item.SharpenBlockSizeY = furtherModes.GrayscaleEnhancementModes.options.SharpenSmooth.args.SharpenBlockSizeY.value[i];
      }
      currentTpl.ImageParameterOptions[0].GrayscaleEnhancementModes.push(item);
    }
  }

  // GrayscaleTransformationModes
  currentTpl.ImageParameterOptions[0].GrayscaleTransformationModes = [];
  for (let i = 0; i < furtherModes.GrayscaleTransformationModes.value.length; i++) {
    if (furtherModes.GrayscaleTransformationModes.value[i] === "GTM_AUTO") continue;
    const item: any = {
      Mode: furtherModes.GrayscaleTransformationModes.value[i]
    }
    currentTpl.ImageParameterOptions[0].GrayscaleTransformationModes.push(item);
  }

  // RegionPredetectionModes
  currentTpl.ImageParameterOptions[0].RegionPredetectionModes = [];
  if (_isOnlyHas(furtherModes.RegionPredetectionModes.value, "RPM_SKIP")) {
    (currentTpl as any).ImageParameterOptions[0].RegionPredetectionModes = [{
      Mode: "RPM_SKIP"
    }];
  } else {
    const removeIndex = _removeItemIndex(furtherModes.RegionPredetectionModes.value);
    for (let i = 0; i < furtherModes.RegionPredetectionModes.value.length; i++) {
      if (removeIndex === i) break;
      const item: any = {
        Mode: furtherModes.RegionPredetectionModes.value[i]
      }
      if (furtherModes.RegionPredetectionModes.value[i] === "RPM_GENERAL_RGB_CONTRAST") {
        item.MinImageDimension = furtherModes.RegionPredetectionModes.options.RGB.args.MinImageDimension.value[i];
        item.Sensitivity = furtherModes.RegionPredetectionModes.options.RGB.args.Sensitivity.value[i];
        item.SpatialIndexBlockSize = furtherModes.RegionPredetectionModes.options.RGB.args.SpatialIndexBlockSize.value[i];
      } else if (furtherModes.RegionPredetectionModes.value[i] === "RPM_GENERAL_GRAY_CONTRAST") {
        item.MinImageDimension = furtherModes.RegionPredetectionModes.options.Gray.args.MinImageDimension.value[i];
        item.Sensitivity = furtherModes.RegionPredetectionModes.options.Gray.args.Sensitivity.value[i];
        item.SpatialIndexBlockSize = furtherModes.RegionPredetectionModes.options.Gray.args.SpatialIndexBlockSize.value[i];
      } else if (furtherModes.RegionPredetectionModes.value[i] === "RPM_GENERAL_HSV_CONTRAST") {
        item.MinImageDimension = furtherModes.RegionPredetectionModes.options.HSV.args.MinImageDimension.value[i];
        item.Sensitivity = furtherModes.RegionPredetectionModes.options.HSV.args.Sensitivity.value[i];
        item.SpatialIndexBlockSize = furtherModes.RegionPredetectionModes.options.HSV.args.SpatialIndexBlockSize.value[i];
      }
      currentTpl.ImageParameterOptions[0].RegionPredetectionModes.push(item);
    }
  }

  // TextureDetectionModes
  currentTpl.ImageParameterOptions[0].TextureDetectionModes = [];
  if (_isOnlyHas(furtherModes.TextureDetectionModes.value, "TDM_SKIP")) {
    (currentTpl as any).ImageParameterOptions[0].TextureDetectionModes = [{
      Mode: "TDM_SKIP"
    }];
  } else {
    const removeIndex = _removeItemIndex(furtherModes.TextureDetectionModes.value);
    for (let i = 0; i < furtherModes.TextureDetectionModes.value.length; i++) {
      if (removeIndex === i) break;
      const item: any = {
        Mode: furtherModes.TextureDetectionModes.value[i]
      }
      if (furtherModes.TextureDetectionModes.value[i] === "TDM_GENERAL_WIDTH_CONCENTRATION") {
        item.Sensitivity = furtherModes.TextureDetectionModes.options.GeneralWidthConcentration.args.Sensitivity.value[i];
      }
      currentTpl.ImageParameterOptions[0].TextureDetectionModes.push(item);
    }
  }

  return currentTpl;
}

function _isOnlyHas(arr: Array<string>, name: string) {
  return arr.every(value => value === name);
}

function _removeItemIndex(arr: Array<string>) {
  for (let i = arr.length - 1; i >= 0; i--) {
    if (!arr[i].includes("SKIP")) return i + 1;
  }
  return arr.length - 1;
}